import { categoryInformation } from './category-information-en.i18n';

export const en = {
  categoryInformation,
};
